/* eslint-disable semi */
// Copyright (c) 2019 Deere & Company

const modes = [{
    mode: 'SERIES',
    modePrefix: 'productSeries',
},
{
    mode: 'SUBSERIES',
    modePrefix: 'productSubSeries',
},
{
    mode: 'BASECODE',
    modePrefix: 'baseCode',
},
{
    mode: 'SEARCH',
    modePrefix: '',
}];

export const getDefaultMode = () => modes[0].mode;

export const getNextMode = currentMode => {

    const index = modes.findIndex( mode => mode.mode === currentMode );
    if ( modes[index + 1] ) return modes[index + 1].mode;
    return '';

};

export const getPreviousMode = currentMode => {

    const index = modes.findIndex( mode => mode.mode === currentMode );
    if ( modes[index - 1] ) return modes[index - 1].mode;
    return '';

};

export const getModePrefix = currentMode => {

    const index = modes.findIndex( mode => mode.mode === currentMode );
    if ( modes[index] ) return modes[index].modePrefix;
    return '';

};
